import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import styles from '@patternfly/react-styles/css/components/DescriptionList/description-list.mjs';
import { css } from '@patternfly/react-styles';
export const DescriptionListTermHelpText = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (_jsx("dt", Object.assign({ className: css(styles.descriptionListTerm, className) }, props, { children: children })));
};
DescriptionListTermHelpText.displayName = 'DescriptionListTermHelpText';
//# sourceMappingURL=DescriptionListTermHelpText.js.map